const KL_WISHLIST_STORAGE_KEY = 'kl:wishlist';
const KL_WISHLIST_LIMIT = 60;
const KL_WISHLIST_BUTTON_SELECTOR = '[data-kl-wishlist]';
const KL_WISHLIST_COUNT_SELECTOR = '[data-kl-wishlist-count]';
const KL_WISHLIST_CHANGE_EVENT = 'kl:wishlist:change';
const KL_WISHLIST_SYNC_EVENT = 'kl:wishlist:sync';
const KL_WISHLIST_PRUNE_EVENT = 'kl:wishlist:prune';
const KL_WISHLIST_TOGGLE_EVENT = 'kl:wishlist:toggle';

function normalizeHandles(handles) {
  const normalized = [];

  handles.forEach((handle) => {
    if (typeof handle !== 'string') return;

    const trimmed = handle.trim();

    if (trimmed === '' || normalized.includes(trimmed)) return;

    normalized.push(trimmed);
  });

  return normalized.slice(0, KL_WISHLIST_LIMIT);
}

function parseWishlist(rawValue) {
  if (typeof rawValue !== 'string' || rawValue === '') return [];

  const parsed = JSON.parse(rawValue);

  if (!Array.isArray(parsed)) return [];

  return normalizeHandles(parsed);
}

function toggleHandle(handles, handle) {
  if (handles.includes(handle)) {
    return handles.filter((saved) => saved !== handle);
  }

  return normalizeHandles([handle].concat(handles));
}

function removeHandles(handles, unwanted) {
  return handles.filter((saved) => !unwanted.includes(saved));
}

function getWishlistCountText(count) {
  return count > 99 ? '99+' : String(count);
}

function readWishlist() {
  try {
    return parseWishlist(localStorage.getItem(KL_WISHLIST_STORAGE_KEY));
  } catch (error) {
    console.debug('kl-wishlist: could not read the saved list', { error });
    return [];
  }
}

function writeWishlist(handles) {
  try {
    localStorage.setItem(KL_WISHLIST_STORAGE_KEY, JSON.stringify(handles));
    return true;
  } catch (error) {
    console.debug('kl-wishlist: could not save the list', { count: handles.length, error });
    return false;
  }
}

function renderButtons(handles) {
  document.querySelectorAll(KL_WISHLIST_BUTTON_SELECTOR).forEach((button) => {
    const handle = button.dataset.klWishlistHandle;

    if (!handle) return;

    const isSaved = handles.includes(handle);

    button.setAttribute('aria-pressed', String(isSaved));
    button.classList.toggle('is-active', isSaved);
  });
}

function renderCount(handles) {
  document.querySelectorAll(KL_WISHLIST_COUNT_SELECTOR).forEach((element) => {
    element.textContent = getWishlistCountText(handles.length);
    element.hidden = handles.length === 0;
  });
}

function render(handles) {
  renderButtons(handles);
  renderCount(handles);
}

function publishWishlistChange(handles) {
  document.dispatchEvent(new CustomEvent(KL_WISHLIST_CHANGE_EVENT, { detail: { handles } }));
}

function commit(handles) {
  if (!writeWishlist(handles)) return;

  render(handles);
  publishWishlistChange(handles);
}

function handleButtonClick(button) {
  const handle = button.dataset.klWishlistHandle;

  if (!handle) {
    console.debug('kl-wishlist: a heart has no product handle to save', {
      productId: button.dataset.klWishlistProduct,
    });
    return;
  }

  const handles = toggleHandle(readWishlist(), handle);

  commit(handles);

  button.dispatchEvent(
    new CustomEvent(KL_WISHLIST_TOGGLE_EVENT, {
      bubbles: true,
      detail: {
        isActive: handles.includes(handle),
        productHandle: handle,
        productId: button.dataset.klWishlistProduct,
        wishlistCount: handles.length,
      },
    })
  );
}

function handlePrune(unwanted) {
  if (!Array.isArray(unwanted) || unwanted.length === 0) return;

  const handles = readWishlist();
  const pruned = removeHandles(handles, unwanted);

  if (pruned.length === handles.length) return;

  commit(pruned);
}

document.addEventListener('click', (event) => {
  const button = event.target.closest(KL_WISHLIST_BUTTON_SELECTOR);

  if (!button) return;

  handleButtonClick(button);
});

document.addEventListener(KL_WISHLIST_SYNC_EVENT, () => {
  render(readWishlist());
});

document.addEventListener(KL_WISHLIST_PRUNE_EVENT, (event) => {
  handlePrune(event.detail?.handles);
});

window.addEventListener('storage', (event) => {
  if (event.key !== KL_WISHLIST_STORAGE_KEY) return;

  const handles = readWishlist();

  render(handles);
  publishWishlistChange(handles);
});

window.addEventListener('pageshow', () => {
  render(readWishlist());
});

let isSyncScheduled = false;

function scheduleSync() {
  if (isSyncScheduled) return;

  isSyncScheduled = true;

  requestAnimationFrame(() => {
    isSyncScheduled = false;
    render(readWishlist());
  });
}

function hasWishlistButton(node) {
  if (!(node instanceof Element)) return false;

  return node.matches(KL_WISHLIST_BUTTON_SELECTOR) || Boolean(node.querySelector(KL_WISHLIST_BUTTON_SELECTOR));
}

new MutationObserver((mutations) => {
  const hasNewButton = mutations.some((mutation) => Array.from(mutation.addedNodes).some(hasWishlistButton));

  if (!hasNewButton) return;

  scheduleSync();
}).observe(document.documentElement, { childList: true, subtree: true });

render(readWishlist());
